import axios from 'axios';
import { Message } from 'element-ui';
import errorCode from '@/utils/errorCode';
import app from '@/main';
import router from '@/router/index';
import {goLogin} from '@/utils/judge';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '',
  // 超时
  timeout: 30000,
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    const configTemp = { ...config };
    if (app.$store.getters.token || sessionStorage.getItem('token_portalUI')) {
      const token = app.$store.getters.token || sessionStorage.getItem('token_portalUI');
      configTemp.headers = {
        ...configTemp.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    app.$Progress.start();
    return configTemp;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    app.$Progress.finish();
    if (res.request.responseType === 'blob' || res.config.responseType === 'arraybuffer') {
      return res;
    }
    if (Number(res.data.code) === 0 || Number(res.data.code) === 200) {
      return res;
    }
    if ([100, 102, 401, 30106].includes(res.data.code)) {
      Message({
        message: res.data.message || 'token过期请重新登录',
        type: 'error',
        duration: 5 * 1000,
      });
      goLogin();
    } else {
      const message = res.data.msg || res.data.message || res.data.msg_show || '请求出错';
      Message.error({
        message,
      });
      return Promise.reject(res);
    }
    return 0;
  },
  (error) => {
    app.$Progress.fail();

    const code = error && error.response ? error.response.status : 'default';
    const message = error.response && error.response.data && error.response.data.msg_show
      ? error.response.data.msg_show
      : errorCode[code];
    if (
      error.response
      && error.response.status === 403) {
      app.$store.dispatch('Logout')
        .then(() => {
          setTimeout(() => {
            goLogin();
          });
        });
    }
    Message({
      message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);
service.all = axios.all;
service.spread = axios.spread;
export default service;
